<car [ngClass]="{
  'full-width static': layoutService?.state?.isFullWidth
}">
</car>
<spin></spin>
<app-error></app-error>
